import React from 'react';

export interface SamplePillProps {
  className?: string;
}

/** "Sample" badge for the sample patient (Phase 13, ACC-16): made-up data, not real PHI. */
export function SamplePill({ className = '' }: SamplePillProps) {
  return (
    <span
      data-testid="sample-pill"
      title="Sample patient — not real PHI"
      className={`inline-flex items-center rounded border border-violet-300 bg-violet-100 px-2 py-0.5 text-xs font-semibold text-violet-800 ${className}`.trim()}
    >
      Sample
    </span>
  );
}

export default SamplePill;
